import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ProductSpec } from "@/data/phoneSpecs";

export const useAccessories = () => {
  return useQuery({
    queryKey: ["accessories"],
    queryFn: async (): Promise<ProductSpec[]> => {
      const { data, error } = await supabase
        .from("accessories")
        .select("*")
        .eq("active", true)
        .eq("is_archived", false)
        .order("created_at", { ascending: true });

      if (error) throw error;

      return (data || []).map((p: any) => ({
        id: p.id,
        name: p.name,
        color: p.color,
        price: Number(p.price).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
        priceNum: Number(p.price),
        image: p.image_url,
        stock: p.stock,
        specs: p.specs as ProductSpec["specs"],
        ratings: p.ratings as ProductSpec["ratings"],
      }));
    },
  });
};
